<template>
    <div class="message">
        <div class="head">
            <h6>{{message.subject}}</h6>
            <div>{{message.created_at | moment('dddd, MMMM Do YYYY, h:mm:ss a')}}</div>
            <div v-if="isLetter"><strong>Mailed to: </strong>{{message.to}}</div>
            <div v-else><strong>To: </strong>{{message.to}}</div>
        </div>

        <div v-if="isLetter" class="letter-card">
            <div class="letter-card-head">
                <i class="fas fa-mailbox mr-2"></i>
                <span>This notice was sent as a printed letter through the U.S. Postal Service.</span>
            </div>
            <div v-if="message.pdf_available" class="mt-3">
                <a :href="letterPdfUrl" target="_blank" rel="noopener" class="btn btn-sm btn-primary">
                    <i class="fas fa-file-pdf mr-2"></i>View Letter (PDF)
                </a>
            </div>
        </div>

        <div v-html="message.raw_html"/>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import {apiUrl} from '@/constants/config';

    export default {
        name: "Message",
        props: ['code', 'id'],
        data: function() {
            return {
                message: {}
            }
        },
        computed: {
            isLetter: function() {
                return typeof this.message.type === 'string' && this.message.type.indexOf('letter-') === 0;
            },
            letterPdfUrl: function() {
                return apiUrl + 'api/user/comm/' + this.code + '/' + this.id + '/letter';
            }
        },
        methods: {
            ...mapActions(['getMessage']),
            loadMessage: function() {
                this.getMessage({secret: this.code, id: this.id}).then(message => {
                    this.message = message;
                }, err => {
                    this.$router.push({name: 'home'});
                    console.error(err);
                });
            }
        },
        watch: {
            'id': function() {
                this.message = {};
                this.loadMessage();
            }
        },
        mounted: function() {
            this.loadMessage();
        }
    };
</script>

<style lang="scss" scoped>
    .message {
        padding: 0.25rem;
        background-color: #f7f7f7;
        border-radius: 0.25rem;

        .head {
            padding: 1rem;
            font-size: 0.9rem;
        }

        .letter-card {
            margin: 0 1rem 1rem;
            padding: 0.9rem 1rem;
            font-size: 0.9rem;
            background-color: #eef4fb;
            border-left: 4px solid #336699;
            border-radius: 0.25rem;

            .letter-card-head {
                display: flex;
                align-items: center;
            }
        }
    }
</style>
